import React, { useState, useEffect } from 'react';
import { arrayOf, string, func } from 'prop-types';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const UgcSortDropdown = ({ enabledSortLinks, selectedSort, setUgcLoading, sortTrailData }) => {
  const [selectedSortOption, updateSelectSort] = useState(selectedSort);

  useEffect(() => {
    if (selectedSort && selectedSortOption !== selectedSort) {
      updateSelectSort(selectedSort);
    }
  }, [selectedSort]);

  const handleSortClick = e => {
    const newSort = e.target.value;
    updateSelectSort(newSort);
    setUgcLoading();
    sortTrailData({ sort_option: newSort });
  };

  return (
    <div className={`${StringConstantsMixin.constants.XLATE.NONE} ${styles.container}`}>
      <div className={styles.labelAndSelect}>
        <div>{StringConstantsMixin.strings.FILTERS.SORT}:</div>
        <select onChange={handleSortClick} className={styles.select} value={selectedSortOption}>
          {enabledSortLinks.map(sortKey => {
            return (
              <option key={sortKey} value={sortKey}>
                {StringConstantsMixin.strings.SORT[sortKey]}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

UgcSortDropdown.propTypes = {
  enabledSortLinks: arrayOf(string),
  selectedSort: string,
  setUgcLoading: func,
  sortTrailData: func
};

UgcSortDropdown.defaultProps = {
  enabledSortLinks: ['atSort', 'desc', 'asc', 'highestRated', 'lowestRated'],
  selectedSort: '',
  setUgcLoading: () => {},
  sortTrailData: () => {}
};

export default UgcSortDropdown;
